import ReservierungNeu from "@/entities/common/reservierung_neu"
import BaseLogic from "../base_logic"
import IdRequest from "@/entities/common/request/id_request"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"

export default class ReservierungLogic extends BaseLogic {
  reservierung: ReservierungNeu

  init(id: string) {
    var request = new IdRequest()
    request.id = id

    Poster.postUser<RemoteResult<ReservierungNeu>>(
      RestPaths.reservierungenDetailsKunde,
      request
    ).then((response) => {
      this.mainLogic.reservierung = new ReservierungNeu()
      this.mainLogic.reservierung = response.data.payload
    })
  }
}
